import { useEffect, useState } from "react";
import { MFButton } from "../../../../common/components/MFButton";
import { MFCheckbox } from "../../../../common/components/MFCheckbox";
import MFModal from "../../../../common/containers/MFModal";
import { toast } from "react-toastify";
import { AlertCircle } from "../../../../assets/icons/AlertCircle";

export function ModalDownloadFiles({
  isOpen,
  onClose,
  displayXmlInies,
  displayXml,
  displayXls,
  calcul,
  filesCreatedAfterSave,
  calculs,
  downloadReports,
}) {
  const [selectedFileTypes, setSelectedFileTypes] = useState([
    ...(displayXls ? ["xls"] : []),
    ...(displayXml ? ["xml"] : []),
    ...(displayXmlInies ? ["inies"] : []),
    "pdf",
  ]);

  useEffect(() => {
    setSelectedFileTypes([
      ...(displayXls ? ["xls"] : []),
      ...(displayXml ? ["xml"] : []),
      ...(displayXmlInies ? ["inies"] : []),
      "pdf",
    ]);
  }, [displayXls, displayXml, displayXmlInies]);

  function handleFileTypeChange(e) {
    const value = e.target.value;
    if (selectedFileTypes.includes(value)) {
      setSelectedFileTypes(selectedFileTypes.filter((type) => type !== value));
    } else {
      setSelectedFileTypes([...selectedFileTypes, value]);
    }
  }

  function downloadFiles() {
    if (calcul) {
      selectedFileTypes.forEach((type) => {
        if (calcul.reports && calcul.reports[type] && filesCreatedAfterSave()) {
          window.open(calcul.reports[type]);
        }
      });
      toast.success(`Téléchargements terminés`);
    } else if (calculs && downloadReports) {
      if (calculs.some((calcul) => !calcul.isFinished)) {
        toast.info(
          `Certains calculs sélectionnés étant au statut 'En cours', les exports de ces calculs ne seront pas téléchargés`,
        );
      }
      downloadReports(selectedFileTypes);
    }
    onClose();
  }

  function hasSelectedNotDownloadable() {
    if (calculs) {
      return selectedFileTypes.some((type) =>
        calculs.some(
          (calcul) => !calcul.outputs?.some((output) => output.includes(type)),
        ),
      );
    } else return false;
  }

  return (
    <MFModal
      isOpen={isOpen}
      onClose={onClose}
      dialogClassName="modal-download-files"
    >
      <p className="modal-title">
        Dans quel(s) format(s) souhaitez-vous télécharger les exports ?
      </p>
      <div className="d-flex flex-column mb-1">
        <MFCheckbox
          checked={selectedFileTypes.includes("pdf")}
          onChange={handleFileTypeChange}
          value="pdf"
          label="PDF"
          marginBottom={15}
        />
        {displayXmlInies && (
          <MFCheckbox
            checked={selectedFileTypes.includes("inies")}
            onChange={handleFileTypeChange}
            value="inies"
            label="XML Inies"
            marginBottom={15}
          />
        )}
        {displayXml && (
          <MFCheckbox
            checked={selectedFileTypes.includes("xml")}
            onChange={handleFileTypeChange}
            value="xml"
            label="XML"
            marginBottom={15}
          />
        )}
        {displayXls && (
          <MFCheckbox
            checked={selectedFileTypes.includes("xls")}
            onChange={handleFileTypeChange}
            value="xls"
            label="XLS"
            marginBottom={10}
          />
        )}
      </div>
      {hasSelectedNotDownloadable() && (
        <div className="error-div">
          <div className="error-logo">
            <AlertCircle size={22} />
          </div>
          Attention certains exports sont disponibles uniquement pour certains
          calculs sélectionnés.
        </div>
      )}
      <div className="d-flex align-items-center justify-content-end mt-2">
        <MFButton
          className="mr-1"
          style={{ fontSize: 15 }}
          cancelButton
          onClick={onClose}
        >
          Annuler
        </MFButton>
        <MFButton
          disabled={selectedFileTypes.length === 0}
          style={{ fontSize: 15 }}
          onClick={downloadFiles}
        >
          Télécharger
        </MFButton>
      </div>
    </MFModal>
  );
}
